import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {


  transform(value: string): SafeHtml {
    if (!value) {
      return value;
    }

    // Regular Expression برای یافتن URL ها
    const urlPattern = /https?:\/\/[^\s]+/g;
    
    // جایگزینی لینک‌ها با تگ <a>
    const replacedText = value.replace(urlPattern, (url) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });

    return replacedText;
  }

}
